import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OrderProductShortTermRentalJoinService } from '../order-products-short-term-rental-join.service';
import { OrderProductShortTermRentalJoin } from '../order-products-short-term-rental-join';
import { OrderProductShortTermRentalJoinComponent } from '../order-products-short-term-rental-join/order-products-short-term-rental-join.component';

@Component({
    selector: 'app-order-products-short-term-rental-join-list',
    templateUrl: './order-products-short-term-rental-join-list.component.html',
    styleUrls: ['./order-products-short-term-rental-join-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OrderProductShortTermRentalJoinListComponent implements OnInit {
	chargeTypes: any;
	feeTypes: any;
	feeFrequencies: any;
	constructor(
		private orderProductShortTermRentalJoinService: OrderProductShortTermRentalJoinService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = orderProductShortTermRentalJoinService.statuses;
		this.chargeTypes = orderProductShortTermRentalJoinService.chargeTypes;
		this.feeTypes = orderProductShortTermRentalJoinService.feeTypes;
		this.feeFrequencies = orderProductShortTermRentalJoinService.feeFrequencies;
	}

	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() orderProductId: any;
	@Input() shortTermRentalId: any;
	@Input() targetPropertyLength: any;
	@Output() reloadProperties = new EventEmitter<any>();
	orderProductShortTermRentalJoins: any;
	orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'ShortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'ShortTermRentalVO.bedrooms', header: 'Bedrooms', width: 'auto' },
		{ field: 'ShortTermRentalVO.addressCounty', header: 'County', width: 'auto' },
		{ field: 'valueAMT', header: 'AMT', width: 'auto' },
		{ field: 'valuePCT', header: 'PCT', width: 'auto' },
		{ field: 'feeType', header: 'Fee Type', width: 'auto' },
		{ field: 'feeFrequency', header: 'Fee Freq', width: 'auto' }, 
		{ field: 'addToRate', header: 'Add To Rate', width: 'auto' },
		{ field: 'showToCustomer', header: 'Show To Customer', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.orderProductShortTermRentalJoinId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) { 
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-orderProductShortTermRentalJoin-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if(this.orderProductId)
			{
				// show only activities that are assigned to this activityId
				let orderProductIdFilter = { 'orderProductId': { 'value': this.orderProductId, 'matchMode': 'in' } };
				Object.assign(event.filters, orderProductIdFilter);
			}

			// if(this.shortTermRentalId)
			// {
			// 	// show only activities that are assigned to this activityId
			// 	let shortTermRentalIdFilter = { 'ShortTermRentalVO.shortTermRentalId': { 'value': this.shortTermRentalId, 'matchMode': 'in' } };
			// 	Object.assign(event.filters, shortTermRentalIdFilter);
			// }

			const pageNumber = Math.round(event.first / event.rows);
			this.orderProductShortTermRentalJoinService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.orderProductShortTermRentalJoins = res.data.orderProductShortTermRentalJoins;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.orderProductShortTermRentalJoins = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin) {
		try {
			this.formLoading = true;
			this.orderProductShortTermRentalJoinService.update(orderProductShortTermRentalJoin)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.orderProductShortTermRentalJoins.map((orderProductShortTermRentalJoin, i) => {
							if (orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId === res.data.orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId) {
								this.orderProductShortTermRentalJoins[i] = res.data.orderProductShortTermRentalJoin;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(orderProductShortTermRentalJoin: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(orderProductShortTermRentalJoin));

			this.formLoading = true;
			this.orderProductShortTermRentalJoinService.delete(orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.orderProductShortTermRentalJoins.splice(this.orderProductShortTermRentalJoins.indexOf(orderProductShortTermRentalJoin), 1);
						this.recordTotal = this.orderProductShortTermRentalJoins.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OrderProductShortTermRentalJoin ' + orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OrderProductShortTermRentalJoin ' + orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Order Product ShortTermRental Join',
			orderProductId: this.orderProductId,
			shortTermRentalId: this.shortTermRentalId,
			orderProductShortTermRentalFlag: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.addOrderProductShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			orderProductShortTermRentalJoin: orderProductShortTermRentalJoin,
			title: 'Edit Order Product ShortTermRental Join',
			orderProductId: this.orderProductId,
			shortTermRentalId: this.shortTermRentalId,
			orderProductShortTermRentalFlag: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OrderProductShortTermRentalJoinComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.updateOrderProductShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deleteOrderProductShortTermRentalJoinCB(data);
				this.loadLazy(this.lazyLoadEvent);
				this.reloadProperties.emit(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOrderProductShortTermRentalJoinCB(orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin) {
		console.log('Adding OrderProductShortTermRentalJoin: ' + JSON.stringify(orderProductShortTermRentalJoin));
		// if we don't have a orderProductShortTermRentalJoins array yet...
		if (!this.orderProductShortTermRentalJoins) {
			this.orderProductShortTermRentalJoins = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.orderProductShortTermRentalJoins.unshift(orderProductShortTermRentalJoin);

		// no idea what this is but it is required to update the array
		this.orderProductShortTermRentalJoins = [...this.orderProductShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductShortTermRentalJoin ' + orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId + ' Added', life: 3000 });
	}

	updateOrderProductShortTermRentalJoinCB(orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin) {
		console.log('Updating OrderProductShortTermRentalJoin: ' + JSON.stringify(orderProductShortTermRentalJoin));
		let itemIndex = this.orderProductShortTermRentalJoins.findIndex((item: any) => item.orderProductShortTermRentalJoinId === orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId);
		this.orderProductShortTermRentalJoins[itemIndex] = orderProductShortTermRentalJoin;

		// no idea what this is but it is required to update the array
		this.orderProductShortTermRentalJoins = [...this.orderProductShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductShortTermRentalJoin ' + orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId + ' Updated', life: 3000 });
	}

	deleteOrderProductShortTermRentalJoinCB(orderProductShortTermRentalJoin: OrderProductShortTermRentalJoin) {
		console.log('Removing OrderProductShortTermRentalJoin: ' + orderProductShortTermRentalJoin);
		this.orderProductShortTermRentalJoins.splice(this.orderProductShortTermRentalJoins.indexOf(orderProductShortTermRentalJoin), 1);
		this.recordTotal = this.orderProductShortTermRentalJoins.length;

		// no idea what this is but it is required to update the array
		this.orderProductShortTermRentalJoins = [...this.orderProductShortTermRentalJoins];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OrderProductShortTermRentalJoin ' + orderProductShortTermRentalJoin.orderProductShortTermRentalJoinId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.orderProductShortTermRentalJoins ? this.first === (this.orderProductShortTermRentalJoins.length - this.rows) : true; }
	isFirstPage(): boolean { return this.orderProductShortTermRentalJoins ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(orderProductShortTermRentalJoin: any) {
		if (orderProductShortTermRentalJoin?.status) {
			const status = this.statuses.find((e: any) => e.value == orderProductShortTermRentalJoin.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getChargeType(orderProductShortTermRentalJoin: any) {
		if (orderProductShortTermRentalJoin?.chargeType) {
			const status = this.chargeTypes.find((e: any) => e.value == orderProductShortTermRentalJoin.chargeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeType(orderProductShortTermRentalJoin: any) {
		if (orderProductShortTermRentalJoin?.feeType) {
			const status = this.feeTypes.find((e: any) => e.value == orderProductShortTermRentalJoin.feeType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getFeeFrequencies(orderProductShortTermRentalJoin: any) {
		if (orderProductShortTermRentalJoin?.feeFrequency) {
			const status = this.feeFrequencies.find((e: any) => e.value == orderProductShortTermRentalJoin.feeFrequency);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}

	ngOnChanges() {
		/**********THIS FUNCTION WILL TRIGGER WHEN PARENT COMPONENT UPDATES 'someInput'**************/
		//Write your code here
		this.loadLazy(this.lazyLoadEvent);
		} 
}
